export const NotificationLocationCodes = ['partner-homepage', 'program-dashboard', 'winner-resource'] as const;

export const NotificationTypeCodes = ['info', 'warning', 'error', 'success'] as const;

export type NotificationLocationCode = (typeof NotificationLocationCodes)[number];
export type NotificationTypeCode = (typeof NotificationTypeCodes)[number];

export interface Notification {
  notificationId: number;
  programId: number;
  message: string;
  typeCode: NotificationTypeCode;
  displayName: string;
  locationCode: NotificationLocationCode;
  isActive: boolean;
}
